import React from "react";
import PopupModel from "./components/Popup/Popup";

function Home() {
  return (
    <>
      <div
        className="container mx-auto max-w-6xl text-center drop-shadow-lg"
        id="wrapper"
      >
        <PopupModel />
      </div>
    </>
  );
}

export default Home;
